module.exports = __webpack_public_path__ + "static/media/ueLogo.39085d92.png";